import React from 'react';

import { useLocalization } from '../../providers/LocaleProvider';
import type { SpaceProps } from '../../theme/system-types';
import { BodyRegularBR2 } from '../Typography';

const ReCaptchaDisclaimer = (props: SpaceProps) => {
  const { t } = useLocalization();

  return (
    <BodyRegularBR2
      textAlign="center"
      dangerouslySetInnerHTML={{
        __html: t('h24_recaptcha_disclaimer'),
      }}
      {...props}
    />
  );
};

export default ReCaptchaDisclaimer;
